import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { NgxSpinnerService } from 'ngx-spinner';
// import { analytics } from 'src/app/app.module';

@Component({
  selector: 'app-self-learn-chapter',
  templateUrl: './self-learn-chapter.component.html',
  styleUrls: ['./self-learn-chapter.component.css']
})
export class SelfLearnChapterComponent implements OnInit {
  learnBannerData:any;
  subjectName:string="";
  chapterViewMoreStatus: boolean = false;
  headerBannerdata:any = [];
  topicdata:any = [];
  currentTabIndex:number = 0;
  expandRowIndex = -1;
  isLoading:boolean = true;
  memoryCardQuestionsData:any;
  isMemoryCardsAvailable:any;
  InteractiveStoriesList:any;
  isInteracticeCardsAvailable:any;
  constructor(public selfLearnService: SelfLearnService, public spinner:NgxSpinnerService) { }

  ngOnInit(): void {
    this.getTopicsAndVideosForExamChapterSubtenant();
    this.currentTabIndex = (localStorage.getItem('currentChapterTabIndex') == undefined) ? 0 : Number(localStorage.getItem('currentChapterTabIndex'));
    this.getMemoryCardQuestions();
    this.getInteractiveStoriesForExamNodeIds();
    localStorage.removeItem('practiceLastViewQustionNumber');
    localStorage.removeItem('selfLearnSelectedPlayList');
    localStorage.removeItem("selfLearnSelectedPlayName");
    localStorage.removeItem("selfLearnSelectedVideoType");
    
  }

  getTopicsAndVideosForExamChapterSubtenant(){
    const chapterId = localStorage.getItem("chapterId");
    this.spinner.show();
    this.selfLearnService.getTopicsAndVideosForExamChapterSubtenant(chapterId).subscribe((resp:any) => {
      this.spinner.hide();
      const bannerData =  {
           bannerTitle: resp?.data?.parent.chapterName,
           chapterLession: '',
           progress: 0,
           chapterCount: resp?.data?.parent?.practiceTotalTopicsCount,
           subjectIcon:  resp?.data?.parent?.icon
         }
      this.subjectName = resp?.data?.parent.subjectName;
      this.learnBannerData = resp?.data?.parent;
      this.headerBannerdata.push(bannerData);
      this.topicdata = resp?.data?.child;
      localStorage.setItem('selctedChapterTopics',JSON.stringify(this.topicdata));
      this.getTopicAndVideosProgress();
    })
  }

  getResumeLearningForHomeScreen(){
    this.spinner.show();
    this.selfLearnService.getResumeLearningForHomeScreen().subscribe((resp:any) => {
      this.spinner.hide();
      if(resp && resp.status){
        this.topicdata.map((item:any, row:any) => {
          if(resp.data.topicId == item.topicId) {this.expandRowIndex  = row}
        })
      }
      this.setTabDefaultData();
     this.calculateExpandRowIndex();
    })
  }
  setTabDefaultData(){
    if(localStorage.getItem('currentChapterTabIndex') != undefined){
      if( this.currentTabIndex==1){
        this.isMemoryCardsAvailable = this.memoryCardQuestionsData.length > 0 ? true : false;
        this.isInteracticeCardsAvailable = false;
      }else if(this.currentTabIndex==2){
        this.isInteracticeCardsAvailable = this.InteractiveStoriesList.length > 0 ? true : false;
        this.isMemoryCardsAvailable = false;
      }else{
        this.isInteracticeCardsAvailable = this.InteractiveStoriesList.length > 0 ? true : false;
        this.isMemoryCardsAvailable = this.memoryCardQuestionsData.length > 0 ? true : false;
      }
    }
  }
  calculateExpandRowIndex(){
    if(this.expandRowIndex < 1){
      for (let index = 0; index < this.topicdata.length; index++) {
        const item = this.topicdata[index];
        if(item.isCompleted == undefined || item.isCompleted == false) {
          this.expandRowIndex  = index;
          this.checkAndExpandIfTopicSelected();
          return;
        }
      }
      this.expandRowIndex  = 0;
      this.checkAndExpandIfTopicSelected();
    }
  }

  checkAndExpandIfTopicSelected(){
    this.expandRowIndex = (localStorage.getItem('learnTabExpandIndex') != undefined) ?
                           Number(localStorage.getItem('learnTabExpandIndex')) : this.expandRowIndex;
    // this.selfLearnService.removlearnTabExpandRowIndex();
  }

  getTopicAndVideosProgress(){
    const chapterId = localStorage.getItem("chapterId");
    const subjectId = localStorage.getItem("selfLearnSelectedSubject");
    this.spinner.show();
    this.selfLearnService.getTopicAndVideosProgress(subjectId, chapterId).subscribe((resp:any) => {
      this.spinner.hide();
      this.isLoading = false;
      if(resp?.data == null) {this.calculateExpandRowIndex(); return};
      this.topicdata = this.topicdata.map((item:any, row:any) => {
      const found = resp?.data?.topics.find((element:any) => item.topicId == element.topicId);
      if(found){
       item['completedVideosCount'] = found.completedVideosCount;
       item['inProgressVideosCount'] = found.inProgressVideosCount;
       item['isCompleted'] = found.isCompleted;
       item['topicProgress'] = found.topicProgress;
       item['isexerciseCompleted'] = found.exerciseCompleted;
       item.videos.forEach((elementTopic:any) => {
        found.videos.forEach((elementProgress:any) => {
          if(elementTopic.videoId == elementProgress.videoId){
            elementTopic['isCompleted'] = elementProgress.isCompleted;
            elementTopic['watchedContentInSecs'] = elementProgress.watchedContentInSecs;
            elementTopic['isLastWatch']   = elementProgress.isLastWatch;
            elementTopic['isBookmarked']   = elementProgress.isBookmarked;

          }
        });        
       });
      }
      return {...item};
      });
      this.headerBannerdata[0].progress = Number(resp?.data?.chapterProgress).toPrecision(2);
      this.getResumeLearningForHomeScreen();
    })
  }

  chapterViewMore() {
    this.chapterViewMoreStatus = !this.chapterViewMoreStatus;
  }

  onTabChanged(event:any){
    this.currentTabIndex = event.index;
    localStorage.setItem('currentChapterTabIndex', event.index )
    if( this.currentTabIndex==1){
      this.isMemoryCardsAvailable = this.memoryCardQuestionsData.length > 0 ? true : false;
      this.isInteracticeCardsAvailable = false;
    }else if(this.currentTabIndex==2){
      this.isInteracticeCardsAvailable = this.InteractiveStoriesList.length > 0 ? true : false;
      this.isMemoryCardsAvailable = false;
    }else{
      this.isInteracticeCardsAvailable = this.InteractiveStoriesList.length > 0 ? true : false;
      this.isMemoryCardsAvailable = this.memoryCardQuestionsData.length > 0 ? true : false;
    }
  }
  getMemoryCardQuestions(){
    this.selfLearnService.getTopicsAndMemoryFlashcardsForExamChapterSubtenant().subscribe((res:any) => {
    this.memoryCardQuestionsData = res.data.flashcards;
    this.isMemoryCardsAvailable  = this.memoryCardQuestionsData.length >0 ? true : false;
  })
}
getInteractiveStoriesForExamNodeIds(){
  this.selfLearnService.getStoriesForExamNodeIds('interactive').subscribe((resp:any) => {
    this.InteractiveStoriesList = resp?.data;
    this.isInteracticeCardsAvailable =  this.InteractiveStoriesList.length > 0 ? true : false;

  })
}
changeTabIndex(event:any){
  this.currentTabIndex = event;
}
}
